import { html } from "htm/preact";
import {
  TextFieldEntry,
  isTextFieldEntryEdited,
} from "@bpmn-io/properties-panel";
import { useService } from "bpmn-js-properties-panel";
import type { Element } from "diagram-js/lib/model/Types";

interface ProcessProps {
  element: Element;
  id: string;
  entry: any;
  description: string;
}

export default function processGeneralProps(element: Element) {
  return [
    {
      id: "label",
      element,
      component: Item,
      entry: TextFieldEntry,
      isEdited: isTextFieldEntryEdited,
      description: "",
    },
    /* {
      id: "name",
      element,
      component: Item,
      entry: TextFieldEntry,
      isEdited: isTextFieldEntryEdited,
      description: "",
    },*/
    {
      id: "code",
      element,
      component: Item,
      entry: TextFieldEntry,
      isEdited: isTextFieldEntryEdited,
      description: "",
    },
    {
      id: "title",
      element,
      component: Item,
      entry: TextFieldEntry,
      isEdited: isTextFieldEntryEdited,
      description: "",
    },
    {
      id: "codeTemplate",
      element,
      component: Item,
      entry: TextFieldEntry,
      isEdited: isTextFieldEntryEdited,
      description: "",
    },
  ];
}

function Item(props: ProcessProps) {
  const { element, id, entry } = props;
  const modeling = useService("modeling");
  const translate = useService("translate");
  const debounce = useService("debounceInput");

  const getValue = (): string => {
    return element.businessObject[id] || "";
  };

  const setValue = (value: string) => {
    return modeling.updateProperties(element, {
      [id]: value,
    });
  };

  const label =
    id === "name"
      ? translate("Name")
      : translate(id.charAt(0).toUpperCase() + id.slice(1));

  return html`<${entry}
    id=${id}
    element=${element}
    description=""
    label=${label}
    getValue=${getValue}
    setValue=${setValue}
    debounce=${debounce}
    tooltip=${translate(props.description)}
  />`;
}
